import { store as getStore } from '@alumni-ventures-group/react-shared';
import {
  getRequest,
  getRequestNoErrorHandling,
  postRequest,
  postRequestFormData,
  postLogin,
  getLogout,
} from './request';
import { version } from '@alumni-ventures-group/react-shared/lib/DateHelper-5bca653a';

const USER_TYPE = { 0: 'USER', 1: 'MANAGED' };

const getHeaders = () => {
  const { store } = getStore();
  const { dispatch } = store;
  const sessionCookie = document.cookie.split(';').find((cookie) => {
    const [cookieName] = cookie.split('=');
    return cookieName.trim() === process.env.SESSION_COOKIE_NAME;
  });
  // Session cookie will be automatically sent with request if it exists
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  if (sessionCookie) {
    headers.Authorization = sessionCookie.trim();
  }
  return { headers, dispatch };
};

export const loginInvestor = async (body) => {
  const { headers, dispatch } = getHeaders();
  const mfaRememberMeCookies = document.cookie.split(';').filter((cookie) => {
    const [cookieName] = cookie.split('=');
    return cookieName.trim().includes('mfa_remember_me');
  });
  headers['mfa-remember-me-cookies'] = mfaRememberMeCookies.join(';');
  const res = await postLogin(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/login-user`,
    body,
    headers,
    dispatch,
  );
  return res;
};

export const logoutInvestor = async () => {
  const { headers, dispatch } = getHeaders();
  let userType = 'USER';

  const { store } = getStore();
  if (store) {
    const state = store.getState();
    if (state) {
      const { auth } = state;
      if (auth) {
        const { user } = auth;
        if (user) {
          userType = user.type;
        }
      }
    }
  }

  const res = await getLogout(headers, dispatch, false, USER_TYPE[userType]);
  return res;
};

export const me = async () => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/me`,
    headers,
    dispatch,
  );
  return res;
};

export const getUserInvestments = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-investments${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getLoyaltyRewards = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/loyalty-rewards${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getBuybackData = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/buyback-units${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getBuybackFeedback = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/buyback-feedback${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const submitBuybackFeedback = async (
  body,
  userid = '',
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  return postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/buyback-feedback${userid}`,
    body,
    headers,
    dispatch,
    abortSignal,
  );
};

export const getFundraiseBondInvestments = async (
  userid = '',
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/fundraise-bond-investments${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getFundInvestments = async (
  baseFundCode,
  fundCode,
  userid,
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    // eslint-disable-next-line max-len
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/fund-investments?base-fund-code=${baseFundCode}&fund-code=${fundCode}${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getUserDocuments = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-documents${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getUserMessages = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-messages${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getUserNews = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-news${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const exportK1 = async (userId, fileKey, abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const body = {
    fileKey,
  };

  return postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/export-k1${userId}`,
    body,
    headers,
    dispatch,
    abortSignal,
  );
};

export const exportK1s = async (
  userId,
  connectionId,
  fileKeys,
  year,
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const body = {
    connectionId,
    fileKeys,
    year,
  };

  return postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/export-k1s${userId}`,
    body,
    headers,
    dispatch,
    abortSignal,
  );
};

export const exportK1sv2 = async (
  userId,
  connectionId,
  fileKeys,
  fileIds,
  years,
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const body = {
    connectionId,
    fileKeys,
    years,
    version: '2',
    fileIds,
  };

  return postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/export-k1s${userId}`,
    body,
    headers,
    dispatch,
    abortSignal,
  );
};

export const getK1Metadata = async (
  userid,
  year = 2023,
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const url = new URL(`${process.env.INVESTOR_PORTAL_API_PATH}/api/k1`);

  const params = new URLSearchParams();
  if (userid) {
    params.append('userid', userid);
  }
  if (year) {
    params.append('year', year);
  }
  url.search = params.toString();

  const res = await getRequest(url.toString(), headers, dispatch, abortSignal);
  return res;
};

export const getUserTokens = async (abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-tokens`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getBasecampInvestments = async (fundId, abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/basecamp-investments?fund-id=${fundId}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getDashboardLabels = async (abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/dashboard-labels`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const updateUser = async (body) => {
  const { headers, dispatch } = getHeaders();
  const res = await postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/update-user`,
    body,
    headers,
    dispatch,
  );
  return res;
};

export const sendEmailToIR = async (body) => {
  const { headers, dispatch } = getHeaders();
  const res = await postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/email-investor-relations`,
    body,
    headers,
    dispatch,
  );
  return res;
};

export const sendContactEmail = async (body) => {
  const { headers, dispatch } = getHeaders();
  const res = await postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/send-contact-email`,
    body,
    headers,
    dispatch,
  );
  return res;
};

export const getUserDistributions = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequestNoErrorHandling(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-distributions${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getUserPortfolio = async (
  loadFunds = false,
  loadFundDates = false,
  loadFundFamilies = false,
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequestNoErrorHandling(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/portfolio?loadFunds=${loadFunds}&loadFundDates=${loadFundDates}&loadFundFamilies=${loadFundFamilies}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getFundFamilies = async () => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequestNoErrorHandling(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/fund-families`,
    headers,
    dispatch,
  );
  return res;
};

export const loginManagedUser = async (body) => {
  const { headers, dispatch } = getHeaders();
  const mfaRememberMeCookies = document.cookie.split(';').filter((cookie) => {
    const [cookieName] = cookie.split('=');
    return cookieName.trim().includes('mfa_remember_me');
  });
  headers['mfa-remember-me-cookies'] = mfaRememberMeCookies.join(';');
  const res = await postLogin(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/login-managed-user`,
    body,
    headers,
    dispatch,
  );
  return res;
};

export const getPlan = async (userId = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-investment-plan${userId}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const savePlan = async (body) => {
  const { headers, dispatch } = getHeaders();
  const res = await postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-investment-plan`,
    body,
    headers,
    dispatch,
  );
  return res;
};

export const getFundFamiliesFromWordpressByType = async (
  type = '',
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/fund-families-wp${type}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getFundFamiliesFromCache = async (abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/fund-families`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getFundVintagesFromCache = async (
  fundVintage,
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequestNoErrorHandling(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/fund/${fundVintage}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const updateUserPortfolio = async (
  userPortfolio,
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  return postRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/investment`,
    userPortfolio,
    headers,
    dispatch,
    abortSignal,
  );
};

export const getPlanningConfigFromWordpress = async (abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/planning-config`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getUserFiles = async (
  userid = '',
  documentType = null,
  abortSignal = null,
) => {
  const { headers, dispatch } = getHeaders();
  const queryParams = new URLSearchParams({
    ...(userid ? { userid } : {}),
    ...(documentType ? { documentType } : {}),
  });
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-files${
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    }`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getUserFilesv2 = async (userid = '', abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const queryParams = new URLSearchParams({
    ...(userid ? { userid } : {}),
  });
  const res = await getRequestNoErrorHandling(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/user-files-v2${
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    }`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const downloadFileById = async (fileId, userid, abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/file/${fileId}${userid}`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getK1ConsentNudge = async (abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/electronic-only-k1-consent-nudge`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getAvailableFundsForPortal = async (abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/available-funds`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getActiveSyndications = async (abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequest(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/available-syndications`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

export const getAvailableSyndicationsPage = async (abortSignal = null) => {
  const { headers, dispatch } = getHeaders();
  const res = await getRequestNoErrorHandling(
    `${process.env.INVESTOR_PORTAL_API_PATH}/api/available-syndications-page`,
    headers,
    dispatch,
    abortSignal,
  );
  return res;
};

const postConsentRequest = async (path, body, options = {}) => {
  const { headers } = getHeaders();
  const response = await fetch(`${process.env.INVESTOR_PORTAL_API_PATH}${path}`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers,
    keepalive: !!options.keepalive,
  });
  const responseBody = await response.json().catch(() => null);

  if (!response.ok) {
    return Promise.reject(responseBody || new Error(`Request failed: ${path}`));
  }

  return responseBody;
};

export const getTrackingConsentType = async (reCaptchaToken) => {
  return postConsentRequest('/api/location', { reCaptchaToken });
};

export const logTrackingConsent = async (body) => {
  return postConsentRequest('/api/tracking-consent', body, { keepalive: true });
};
